import { BaseMapper } from '@ps/utils';

import { OperatorCompanyDto } from '../dtos/operator-companies.dto';
import { OperatorCompany } from '../../state/operator-companies/operator-companies-state.model';

export class OperatorCompaniesMapper extends BaseMapper<
  OperatorCompanyDto,
  OperatorCompany
> {
  public override fromDto(dto: OperatorCompanyDto): OperatorCompany {
    return {
      id: dto.id,
      name: dto.name,
      isBuyer: dto.isABuyer,
      isSupplier: dto.isASupplier,
    };
  }
}
